<template>
  <div class="linha" />
</template>

<script>
export default {
  name: "Linha"
};
</script>

<style lang="scss" scoped>
.linha {
  width: 100%;
  height: 1px;
  margin: 32px 0;
  background: linear-gradient(
    to right,
    transparent,
    $corPrimary,
    transparent
  );
}
</style>
